import React, { useContext, useState } from "react";
import { UserContext } from "../UserContext";
import LoadingCircle from "../LoadingCircle";

const Profile: React.FC = () => {
  const { user, updateUserData } = useContext(UserContext);
  const [editing, setEditing] = useState(false);

  const [formData, setFormData] = useState({
    name: user?.name || "",
    email: user?.mail || "",
    phone: user?.phone || "",
  });

  if (!user) {
    return (
      <div>
        <LoadingCircle />
      </div>
    );
  }

  const handleEditToggle = () => {
    setEditing(!editing);

    if (!editing) {
      setFormData({
        name: user.name || "",
        email: user.mail || "",
        phone: user.phone || "",
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Funktion zum Speichern der Änderungen
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await updateUserData({ name: formData.name, phone: formData.phone });
      setEditing(false);
    } catch (error) {
      console.error("Fehler beim Aktualisieren der Benutzerdaten:", error);
      // TODO: Fehlerbehandlung
    }
  };

  return (
    <div className="flex flex-col justify-start items-center py-6 px-3 gap-y-6 w-full h-full overflow-y-auto mt-16">
      <div className="bg-white/10 p-6 rounded-xl shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-semibold text-white mb-6">My Profile</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-white/90 text-md mb-1">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={!editing}
              className={`w-full px-3 py-2 ${
                editing ? "bg-white border" : "bg-white/80"
              } text-zinc-900 placeholder-zinc-500 rounded-xl focus:outline-none focus:shadow-[0_0_10px_black]`}
              placeholder=""
            />
          </div>
          <div>
            <label htmlFor="phone" className="block text-white/90 text-md mb-1">
              Phone
            </label>
            <input
              type="text"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              disabled={!editing}
              className={`w-full px-3 py-2 ${
                editing ? "bg-white border " : "bg-white/80"
              } text-zinc-900 placeholder-zinc-500 rounded-xl focus:outline-none focus:shadow-[0_0_10px_black]`}
              placeholder=""
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-white/90 text-md mb-1">
              E-Mail
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              disabled
              className="w-full px-3 py-2 bg-white/80 text-zinc-900 placeholder-zinc-500 rounded-xl focus:outline-none"
            />
          </div>
          <div>
            {editing ? (
              <div className="flex space-x-4">
                <button
                  type="submit"
                  className="flex-1 py-2 px-4 rounded-xl font-semibold text-white bg-green-500 hover:bg-green-600"
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={handleEditToggle}
                  className="flex-1 py-2 px-4 rounded-xl font-semibold text-white bg-red-500 hover:bg-red-600"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <button
                type="button"
                onClick={handleEditToggle}
                className="w-full py-2 px-4 rounded-xl font-semibold text-white bg-blue-500 hover:bg-blue-600"
              >
                Edit
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Profile;
